import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/* Auto load all route files */
let routes = [];
const rfiles = require.context('./routes', true, /\.js$/i);
rfiles.keys().forEach((key) => {
    const obj = rfiles(key).default;
    if(obj && obj.routes) {
        routes = routes.concat(obj.routes);
    }
});

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0, behavior: 'smooth'};
    }
});

router.beforeEach(async (to, from, next) => {
    router.app.$store.state.pageData = null;
    router.app.$store.state.notFound = false;
    router.app.$store.state.pageTitle = to.meta.name;
    await next();
});

export default router; 